<template>
  <div class="flex fixed w-fit h-14 p-4 bottom-16 right-9 text-[var(--color-orange)]
    bg-[var(--color-white)] rounded-full z-50 border border-[var(--color-orange)]
    cursor-pointer hover:shadow-xl"
    @click="showPopup" >
    <font-awesome-icon icon="fa-circle-info" class="h-6"/>
  </div>
  <Dialog v-model:visible="displayOptions"
    :style="{ width: '20rem' }" position="bottomright">
     <div class="flex h-fit flex-1 mb-4">
      <label class="cursor-pointer text-lg font-normal hover:text-[var(--color-orange)]"
        @click="displayFeedbackForm">{{ $t('ProvideFeedbackComponent.feedback') }}</label>
        <ProvideFeedbackOverlayComponent v-if="showFeedbackDialog" :visible="showFeedbackDialog"
          @update:visible="showFeedbackDialog = $event" :data="notification">
        </ProvideFeedbackOverlayComponent>
    </div>
    <div class="flex h-fit flex-1 mb-4" v-if="hasDemoContent">
      <label class="cursor-pointer text-lg font-normal hover:text-[var(--color-orange)]"
        @click="displayDemoOverlay">{{ $t('ProvideFeedbackComponent.demo') }}</label>
    </div>
  </Dialog>
</template>
<script>
import { Dialog } from 'primevue';
import ProvideFeedbackOverlayComponent from '../Home/Shared/FrontendOverlays/ProvideFeedbackOverlayComponent.vue';

export default {
  name: 'ProvideFeedbackComponent',
  components: { Dialog, ProvideFeedbackOverlayComponent },
  data() {
    return {
      user: {},
      displayOptions: false,
      showFeedbackDialog: false,
      showDialog: false,
      notification: {},
      hasDemoContent: false,
    };
  },
  methods: {
    async displayFeedbackForm() {
      try {
        this.user = this.$store.getters.getUser;
      } catch (e) {
        this.user.userId = this.$store.getters.getUserId;
      } finally {
        this.notification = {
          name: this.user.name || '',
          firstName: this.user.firstName || '',
          userId: this.user.userId || '',
        };
        // this.showPopup();
        this.showFeedbackDialog = true;
      }
    },
    showPopup() {
      this.displayOptions = !this.displayOptions;
    },
    async displayDemoOverlay() {
      await this.$store.dispatch('showNewUserDemo');
      this.showPopup();
    },
  },
  async mounted() {
    this.user = this.$store.getters.getUser;
    if (!this.user?.userId) {
      await this.$store.dispatch('getUserInfo');
    }
    let content = this.$store.getters.getNewUserDemoContent;
    if (!Array.isArray(content) || content.length === 0) {
      await this.$store.dispatch('getNewUserDemoContent');
      content = this.$store.getters.getNewUserDemoContent;
    }
    this.hasDemoContent = Array.isArray(content) && content.length > 0;
  },
};
</script>
